package com.parmartechnologies.core.feature.businessConfig.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.feature.currency.model.Currency
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class BusinessConfig @OptIn(ExperimentalTime::class) constructor(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("currency") var currency: Currency? = null,
): BaseDataClass()
